<template>
  <div style="background: #f5f5f5">
    <HeaderView
      :title="$t('infomation.setname')"
      :right="$t('common.save')"
      :rightclick="'save'"
      @save="save()"
    />
    <div class="view-page">
      <van-cell-group>
        <van-cell :title="$t('infomation.phone')" :value="phone" />
        <van-field
          v-model="newphone"
          :label="$t('infomation.newphone')"
          :placeholder="$t('infomation.phone_place')"
        />
      </van-cell-group>
    </div>
  </div>
</template>

<script>
import HeaderView from "@/components/Header/index.vue";
export default {
  name: "SetPhoneView",
  components: { HeaderView },
  data() {
    return {
      phone:"",
      newphone:null,
      userInfo:{}
    };
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/login'})
    }else {
      this.getUserInfo();
    }
  },
  methods: {
    save(){
      if(this.userInfo.phone){
        this.$toast(this.$t("setting.repect"));
        return true;
      }
      this.$http({
        method: 'get',
        data:{phone:this.newphone},
        url: 'user_set_phone'
      }).then(res=>{
        if(res.code === 200){
          this.getUserInfo();
          this.phone = this.userInfo.phone;
          this.$toast(res.msg);
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          this.phone = res.data.phone;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  },
};
</script>

<style></style>
